import React, { Ref, useState } from 'react'
import styled from 'styled-components'
import { TextInput, View } from 'react-native'
import { Image } from 'ui/common/image'
import { ARROW_RIGHT_PRIMARY_ICON, SEARCH_ICON } from 'image/icon'
import { GO_BUTTON_IMAGE } from 'image'
import { CustomTextInput } from 'ui/common/custom-text-input'
import { BaseText, getLegacyFontStyle } from 'ui/common/text'
import { CURRENT_OS, OS } from 'infra/constant'
import { colors } from 'infra/color'

const isWeb = CURRENT_OS === OS.WEB
const inputFontStyle = getLegacyFontStyle(18)

export const SearchInput: React.FC<{
  editable: boolean
  goButton?: boolean
  inputRef?: Ref<TextInput>
  onChangeText?: (v: string) => void
}> = ({ editable, goButton, inputRef, onChangeText }) => {
  const [value, setValue] = useState('')
  const showWebLabel = isWeb && value.length === 0
  return (
    <SearchInputContainer>
      <Image
        source={SEARCH_ICON}
        style={{
          width: 24,
          height: 24,
          marginRight: 8,
        }}
      />
      {isWeb ? (
        <Field>
          {showWebLabel && (
            <Label
              pointerEvents='none'
              style={
                editable ? { position: 'absolute', left: 0, right: 0 } : undefined
              }
            >
              키워드로 검색해보세요
            </Label>
          )}
          {editable && (
            <Input
              ref={inputRef}
              editable
              onChangeText={(v) => {
                setValue(v)
                onChangeText?.(v)
              }}
            />
          )}
        </Field>
      ) : (
        <Input
          ref={inputRef}
          placeholder='키워드로 검색해보세요'
          editable={editable}
          pointerEvents={editable ? undefined : 'none'}
          onChangeText={onChangeText}
        />
      )}
      {goButton ? (
        <Image
          source={GO_BUTTON_IMAGE}
          style={{
            width: 48,
            height: 32,
            marginHorizontal: 6,
          }}
          resizeMode='contain'
        />
      ) : (
        <Image
          source={ARROW_RIGHT_PRIMARY_ICON}
          style={{
            width: 18,
            height: 18,
            marginHorizontal: 16,
          }}
        />
      )}
    </SearchInputContainer>
  )
}

const SearchInputContainer = styled(View)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 0 4px 12px;
  margin: 0 20px;
  border-radius: 999px;
  background-color: #f2efef;
`

const Field = styled(View)`
  flex: 1;
  justify-content: center;
`

const Label = styled(BaseText)`
  font-size: ${inputFontStyle.fontSize}px;
  line-height: ${inputFontStyle.fontSize}px;
  font-weight: 700;
  color: ${colors.gray.v500};
`

const Input = styled(CustomTextInput)`
  font-size: ${inputFontStyle.fontSize}px;
  font-weight: 700;
  ${
    isWeb
      ? `
  line-height: ${inputFontStyle.fontSize}px;
  height: ${inputFontStyle.fontSize}px;
  padding: 0;
`
      : `
  flex: 1;
  line-height: ${inputFontStyle.lineHeight}px;
  padding: 8px 0;
`
  }
`
